// Мост «Service Worker → Hawk» и сетевые хлебные крошки.
//
// Service Worker живёт в отдельном глобальном контексте: его исключения не
// видит ни `window.onerror`, ни катчер Hawk на странице. При этом именно там
// ломаются вещи, о которых пользователь не напишет в поддержку — прекэш,
// офлайн-навигация, обработчик push. SW шлёт сообщение `sw:error`
// (`public/sw.js`), приложение переправляет его в Hawk.
//
// Здесь же — крошки online/offline: без них падение, случившееся через минуту
// после потери сети, выглядит в Hawk беспричинным.
import { addClientBreadcrumb, captureClientError } from "./hawk-client";

interface ServiceWorkerErrorMessage {
	type: "sw:error";
	source: string;
	message: string;
	stack?: string;
}

function isSwErrorMessage(data: unknown): data is ServiceWorkerErrorMessage {
	return (
		typeof data === "object" &&
		data !== null &&
		(data as { type?: unknown }).type === "sw:error" &&
		typeof (data as { message?: unknown }).message === "string"
	);
}

let installed = false;

/** Подписаться на сигналы рантайма. Идемпотентно, безопасно вне браузера. */
export function initRuntimeSignals(): void {
	if (installed || typeof window === "undefined") return;
	installed = true;

	if ("serviceWorker" in navigator) {
		navigator.serviceWorker.addEventListener("message", (event: MessageEvent) => {
			if (!isSwErrorMessage(event.data)) return;
			const error = new Error(`service-worker: ${event.data.message}`);
			// Стек воркера полезнее пустого стека этого слушателя.
			if (event.data.stack) error.stack = event.data.stack;
			captureClientError(error, { module: "service-worker", source: event.data.source });
		});
	}

	window.addEventListener("offline", () => {
		addClientBreadcrumb("Сеть пропала", undefined, "warning");
	});
	window.addEventListener("online", () => {
		addClientBreadcrumb("Сеть вернулась");
	});
}
